<button mat-mini-fab class="button button-mini-fab"
    (click)="emit_onClick($event)"
    [attr.form]="formName$$()"
    [attr.type]="type$$()"
    [autofocus]="autofocus$$()"
    [class]="class$$()"
    [disabled]="_disabled$$()"
    disabledInteractive
    [matTooltipPosition]="tooltipPosition$$()"
    [matTooltip]="tooltip$$()"
    [style]="style$$()"
    [tabindex]="tabIndex$$()"
    [type]="type$$()"
>
    <div class="content">
        <ng-content />
    </div>
</button>
